import React from "react";
import InitUserPath from "./InitUserPath";
import { createRoot } from "react-dom/client";

const container = document.getElementById("init-user-page");
const root = createRoot(container);

root.render(<InitUserPath />);
